import { Icon } from '~/components/atomic';
import { NavigationMenu } from '../Navigation';
import * as S from './Menu.styled';

interface MenuProps {
  menu: NavigationMenu;
  isActive: boolean;
}

export default function Menu({
  menu: { icon, activeIcon, title },
  isActive,
}: MenuProps) {
  return (
    <S.Menu isActive={isActive}>
      <Icon size={28} iconName={isActive ? activeIcon : icon} />
      <S.Title active={isActive}>{title}</S.Title>
    </S.Menu>
  );
}
